import React, { FC } from 'react';
import { hoverBorderShadow } from 'src/shared/globals';
import { T } from 'src/shared/helpers';
import MdAdd from 'src/shared/icons/plus-solid.svg';
import styled from 'styled-components';
import { useProductConfigurationState } from '../../state';
import { Icon } from '../../../../widgets/icon';
import Loader from 'src/components/widgets/loader';

const ProductImage = styled.div`
    border: 1px ${(props) => props.theme.app.primary_light} solid;
    background-color: #fff;
    border-radius: 8px;
    width: 250px;
    height: 250px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: ${(props) => props.theme.text.boldWeight};
    cursor: pointer;
    margin-top: 20px;

    img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
    }

    ${hoverBorderShadow}
`;

const ProductImageUploadContainer = styled.div`
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    position: relative;
`;

const UploadProductImageMessageContent: FC<{ className?: string }> = ({ className }) => {
    return (
        <div className={className}>
            <Icon>
                <MdAdd />
            </Icon>
            <span>{T._('Upload your product image', 'Admin')}</span>
        </div>
    );
};

const AddProductImageMessage = styled(UploadProductImageMessageContent)`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    ${Icon} {
        width: 28px;
        height: 28px;
    }
`;

interface ProductImageUploadProps {
    onImageClick?: () => void;
}

const ProductImageUpload: FC<ProductImageUploadProps> = ({ onImageClick }) => {
    const { state } = useProductConfigurationState();

    return (
        <ProductImageUploadContainer>
            <div>
                <ProductImage onClick={onImageClick}>
                    {state.productImageUploadProgress != null && state.productImageUploadProgress >= 0 && <Loader />}
                    {state.productImageUploadProgress == null && <AddProductImageMessage />}
                </ProductImage>
            </div>
        </ProductImageUploadContainer>
    );
};

export default ProductImageUpload;
